import { apiPathFunc } from "@api/util/apiPathFunc";

import type { IExtractParams } from "@routes";

const pathBase = `/stores/:storeId/purchase-invoices/:purchaseInvoiceId/returns/:returnId/reclaim/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const reclaim = {
  post: apiPathFunc(pathBase),
};
